// MatchToast.js
import React, { useEffect } from "react";

export default function MatchToast({ visible, partnerName, onClose }) {
  useEffect(() => {
    if (!visible) return;
    const id = setTimeout(onClose, 3500);
    return () => clearTimeout(id);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center pointer-events-none">
      <div className="mb-20 pointer-events-auto rounded-3xl bg-black/80 border border-pink-500/40 px-4 py-3 sm:px-6 sm:py-4 shadow-2xl max-w-sm w-[90%]">
        <div className="flex items-center gap-3">
          <span className="text-2xl">✨</span>
          <div className="flex-1">
            <p className="text-sm font-semibold text-white">
              It&apos;s a match — say hello! 👋
            </p>
            <p className="text-xs text-white/70 mt-0.5">
              You and {partnerName || "your partner"} liked each other.
              Check your Matches after the event.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}